// @import types
import { IHttpResponse } from 'app_types/httpTypes'
import {ICourseExtraInfo} from 'app_types/campus/academic/courseTypes'
import { IRoleListItem } from '../role/roleTypes';
import { ITerm } from '../term/term.types';
// @end

// @add your types
export enum LandingTutorialType {
  IMAGE = 'image',
  PDF = 'pdf',
  VIDEO = 'video',
}

export const LANDING_TUTORIAL_TYPE = {
  [LandingTutorialType.IMAGE]: 'Imagen',
  [LandingTutorialType.PDF]: 'PDF',
  [LandingTutorialType.VIDEO]: 'Video',
}

export interface ILandingArticle {
  slug?: string
  coverFile?: any // Objeto tipo file que contiene la imagen a cargar
  coverUrl?: string // URL de la imagen de la publicación
  coverCaption?: string
  title: string,
  content: any
}

export interface ILandingTrainingsDelete {
  slug: string
  unique: string
}

export interface ILandingTrainings {
  slug?: string
  unique?: string
  status: boolean
  title: string
  description: any
  attachedUrl?: string
  attachedFile?: any // Objeto tipo file que contiene el adjunto a cargar
  publication_date: string
  modality?: string;
  city?: string;
  start_date?: string
  price?: string;
  platform_video?: string;
  url_video?: string;
  course?: {
    program: {
      name: string
      _id: string
    },
    extra_info: ICourseExtraInfo
  }
}

export interface ILandingSchedulingDelete {
  slug: string
  unique: string
}

export interface ILandingScheduling {
  slug?: string
  unique?: string
  title: string
  attachedUrl?: string
  attachedFile?: any // Objeto tipo file que contiene el adjunto a cargar
}

export interface ILandingTermsAndConditions {
  payment?: {
    title: string,
    content: any
  }
}

export interface ILanding extends IHttpResponse {
  landing: {
    _id: string
    title_page?: string
    article?: ILandingArticle
    trainings?: Array<ILandingTrainings>
    alliances?: Array<ILandingAlliance>
    scheduling?: Array<ILandingScheduling>
    descriptive_training?: IDescriptiveTraining
    our_clients?: Array<IOurClient>
    references?: Array<IReferences>
    title_training?: string
    title_references?: string
    title_posts?: string
    forums?: ILangingForums
    tutorials?: Array<ILandingTutorial>
    termsAndConditions?: ILandingTermsAndConditions;
  }
}

export type TypeAgreement = 'alliance' | 'agreement'
export interface IAllianceBrochure {
  unique?: string,
  name?: string
  file?: string,
  fileUrl?: string
}

export type IAllianceBrochureCreate = IAllianceBrochure & { fileToUpload?: any }

export interface IAllianceBrochureParams {
  allianceUnique: string
  slug: string
  brochures: IAllianceBrochureCreate[]
}

export interface ILandingAlliance {
  slug?: string
  unique?: string,
  status?: boolean
  typeAgreement?: TypeAgreement
  agreementDescription?: string
  logo?: string
  logoFile?: string,
  logoUrl?: string,
  name?: string
  country?: string
  regional?: string
  creationYear?: string,
  programs?: string[],
  webSite?:string
  contact?:string
  brochures?: IAllianceBrochure[]
  sectional?: string
  observations?: string
}

export interface IDescriptiveTraining{
  title: string
  content: any
  image: string
}

export interface IOurClient{
  title: string
  url: string
  unique: string
}

export interface IReferences{
  title: string
  attached?: any // Objeto tipo file que contiene la imagen a cargar
  url?: string // URL de la imagen de la publicación
  description: string
  qualification?: string
  unique: string
  client?: string
  created_date?: Date
  active: boolean
}

export interface ILandingDelete {
  id: string // Identificador de la programación
}

export interface ILandingQuery {
  pageNumber?:string, // Numero de pagina
  nPerPage?:string, // Cantidad de elementos por pagina
  select?: string, // Campos de la coleccion a buscar
  search?:string, // Busca sobre los campos de la coleccion
}

export interface IParamsUpdateForumsLanding extends ILangingForums{
  slug: string;
}

export interface IParamsGetLandingData{
  slug: TypeSlugLanding
  onlyActiveReference?: boolean
  onlyActiveTutorials?: boolean
  onlyPublicTutorials?: boolean
}

export interface ILangingForums{
  title?: string;
  description?: string;
}

export interface ILandingTutorialPrivateGroup {
  role: string | Partial<IRoleListItem>;
  groups: ITerm[];
}

export interface ILandingTutorial {
  title: string;
  description: string;
  unique: string;
  imageUrl: string;
  attachUrl: string;
  fileType: LandingTutorialType;
  active: boolean;
  slug?: string;
  imageFile?: any;
  attachFile?: any;
  videoUrl?: string;
  created_at?: Date;
  private?: boolean;
  publicGroups?: ITerm[];
  position: number;
  privateGroups: ILandingTutorialPrivateGroup[];
}

export interface ILandingTutorialParamsUpdateMany {
  tutorials: ILandingTutorial[]
  slug: string
}

export type TypeSlugLanding = 'references' | 'business' | 'officials' | 'student' | 'alliances' | 'tutorials' | 'home' | 'terms-and-conditions';
export type ITrainingFields = 'modality' | 'city' | 'start_date' | 'price' | 'video' | 'description' | 'attached' | 'title' | 'course'

export type IAllianceFields = 'country' | 'regional' | 'creationYear' | 'programs' | 'webSite' | 'contact' | 'sectional'
//@end
